module.exports = __webpack_public_path__ + "static/media/_MIC2479.image.91755356.png";